var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "matrix(1 0 0 -1 12 12)",
    fill: "#838383"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 18H7C6.73488 17.9997 6.4807 17.8942 6.29323 17.7068C6.10576 17.5193 6.0003 17.2651 6 17V7C6.0003 6.73488 6.10576 6.4807 6.29323 6.29323C6.4807 6.10576 6.73488 6.0003 7 6H17C17.2651 6.0003 17.5193 6.10576 17.7068 6.29323C17.8942 6.4807 17.9997 6.73488 18 7V17C17.9997 17.2651 17.8942 17.5193 17.7068 17.7068C17.5193 17.8942 17.2651 17.9997 17 18ZM9 7H7V17H9V7ZM15 10.5H11C10.8674 10.5 10.7402 10.5527 10.6464 10.6464C10.5527 10.7402 10.5 10.8674 10.5 11C10.5 11.1326 10.5527 11.2598 10.6464 11.3536C10.7402 11.4473 10.8674 11.5 11 11.5H15C15.1326 11.5 15.2598 11.4473 15.3536 11.3536C15.4473 11.2598 15.5 11.1326 15.5 11C15.5 10.8674 15.4473 10.7402 15.3536 10.6464C15.2598 10.5527 15.1326 10.5 15 10.5ZM15 12.5H11C10.8674 12.5 10.7402 12.5527 10.6464 12.6464C10.5527 12.7402 10.5 12.8674 10.5 13C10.5 13.1326 10.5527 13.2598 10.6464 13.3536C10.7402 13.4473 10.8674 13.5 11 13.5H15C15.1326 13.5 15.2598 13.4473 15.3536 13.3536C15.4473 13.2598 15.5 13.1326 15.5 13C15.5 12.8674 15.4473 12.7402 15.3536 12.6464C15.2598 12.5527 15.1326 12.5 15 12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportDisable);
export default __webpack_public_path__ + "static/media/report_disable.6ade21ab.svg";
export { ForwardRef as ReactComponent };